import { isEmpty } from '@sgme/fp';
import { Item } from 'models/IItem';

import { ListField } from '../../Addon/components/ListField';

interface OwnProps {
  value: string;
  disabled?: boolean;
  onChange: (newFightingBackJustification: string) => void;
}

const fightingBackJustificationOptions: readonly Item<string>[] = [
  { label: null, value: '' },
  { label: 'Third party error/request', value: 'FB2' },
  { label: 'Technical Issue', value: 'FG2' },
  { label: 'FO error', value: 'FB1' },
];

export function FightingBackJustification({ value, disabled, onChange }: OwnProps) {
  return (
    <ListField
      id="fightingBackJustification"
      e2e="fightback-reason"
      translationKey="form.FightingBackJustification"
      availableItems={fightingBackJustificationOptions}
      disabled={disabled}
      value={value}
      onValueChange={onChange}
      isWarning={isEmpty(value)}
    />
  );
}

FightingBackJustification.displayName = 'FightingBackJustification';
